export default __webpack_public_path__ + "static/media/bu4.a0f69e8b.jpg";